import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities';

class ChampionshipRepository {
  constructor() {
    this.basePath = store.state.backend;
  }

  // Public endpoints — anyone authenticated.

  getChampionshipOverview(championshipId) {
    const headers = { Authorization: store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
    let response = axios.get(`${this.basePath}/ext/championships/${championshipId}/overview`, { headers });
    response = verifyAuth(response);
    return response;
  }

  getChampionshipBracket(championshipId) {
    const headers = { Authorization: store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
    let response = axios.get(`${this.basePath}/ext/championships/${championshipId}/bracket`, { headers });
    response = verifyAuth(response);
    return response;
  }

  listChampionshipParticipants(championshipId) {
    const headers = { Authorization: store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
    let response = axios.get(`${this.basePath}/ext/championships/${championshipId}/participants`, { headers });
    response = verifyAuth(response);
    return response;
  }

  getChampionshipParticipantState(championshipId, userId) {
    const headers = { Authorization: store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
    let response = axios.get(
      `${this.basePath}/ext/championships/${championshipId}/participants/${userId}/state`,
      { headers },
    );
    response = verifyAuth(response);
    return response;
  }

  // Broker admin endpoints — restricted by partner role.

  advanceFromStage(stageId) {
    const headers = { Authorization: store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
    let response = axios.post(
      `${this.basePath}/brokers/championship/admin/stages/${stageId}/advance`,
      null,
      { headers },
    );
    response = verifyAuth(response);
    return response;
  }

  forceMatchWinner(matchId, winnerParticipantId) {
    const headers = { Authorization: store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
    let response = axios.post(
      `${this.basePath}/brokers/championship/admin/matches/${matchId}/force-winner/${winnerParticipantId}`,
      null,
      { headers },
    );
    response = verifyAuth(response);
    return response;
  }
}

export default new ChampionshipRepository();
